// src/pages/Admin/Dashboard/tabs/tickets/index.jsx

import React, { useEffect, useState } from "react";
import CustomDataGrid from "../../../../../components/common/CustomDataGrid";
import { ticketColumns } from "../../../../../constants/columns/ticketColumns";
import {
  getAllQueries,
  deleteQuery,
} from "../../../../../services/api";

export default function Ticket() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchContacts = async () => {
    const res = await getAllQueries();
    setContacts(res.data);
    setLoading(false);
  };

  const handleDelete = async (contact) => {
    if (window.confirm("Delete this query?")) {
      await deleteQuery(contact._id);
      setContacts((prev) =>
        prev.filter((c) => c._id !== contact._id)
      );
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  return (
    <div className="container-fluid">
      <h2>Tickets</h2>

      <CustomDataGrid
        rows={contacts}
        columns={ticketColumns(handleDelete)}
        loading={loading}
        getRowId={(row) => row._id}
      />
    </div>
  );
}
